<section class="aviso-legal" style="padding: 10px 10%; text-align: justify;">
    <header>
        <h1>INFORMACIÓN SOBRE LA POLÍTICA DE PROTECCIÓN DE DATOS SEMANA MUNDIAL</h1>
    </header>
    <ul #scroll>
        <li class="bloque">
            <p class="pregunta" i18n>
                ¿Quién es el responsable del tratamiento de sus datos? 
            </p>
            <p class="respuesta" i18n>
                EL Responsable de tratamiento es:<br />
                Col·legi de Mediadors d’Assegurances de Barcelona (CMAB)<br />
                Passeig de Sant Joan, 33 - 08010  Barcelona<br />
                Teléfono 932153223 <br />
                Email: elcol-legi&#64;elcol-legi.org<br />
                Datos de contacto del Delegado de Protección de Datos: dpd&#64;elcol-legi.org
            </p>
        </li>
        <li class="bloque">
            <p class="pregunta" i18n>
                ¿Con qué finalidad trataremos sus datos personales? 
            </p>
            <p class="respuesta" i18n>
                Trataremos la información que nos facilite con la finalidad de la gestión relativa a la inscripción en el evento 
                de la Semana Mundial del Agente y Corredor de Seguros, gestión de pago inscripciones, emisión de acreditaciones, 
                control de asistencia, así como para el envío de  información de interés sobre el evento y de posteriores actos, 
                noticias e informaciones que puedan ser de su interés. 
            </p>
        </li>
        <li class="bloque">
            <p class="pregunta" i18n>
                ¿Cuál es la legitimación para el tratamiento de sus datos?
            </p>
            <p class="respuesta" i18n>
                La base legal para el tratamiento de sus datos es el consentimiento expreso del interesado para la asistencia al evento 
                y para el tratamiento con la finalidad de enviarle información de interés tales como, noticias, actividades formativas, 
                y otros servicios y eventos del CMAB que puedan ser de su interés.
            </p>
            <p class="respuesta" i18n>
                Para el supuesto que el interesado incluya datos de invitados en la inscripción, será el interesado que realice la inscripción 
                el responsable en relación a la obtención del consentimiento de  los datos personales que ha introducido de los invitados.
            </p>
        </li>
        <li class="bloque">
            <p class="pregunta" i18n>
                ¿Qué datos tratamos?
            <p class="respuesta" i18n>
               Las categorías de datos que se tratan son: datos de identificación, DNI, dirección postal y electrónica, teléfono y datos corporativos.
            </p>
        </li>
        <li class="bloque">
            <p class="pregunta" i18n>
                ¿Cuáles son sus derechos?
            </p>    
            <p class="respuesta" i18n>
               Las personas interesadas tienen derecho a acceder a sus datos personales, así como a solicitar la rectificación de los datos inexactos o, 
               si cabe, solicitar su supresión cuando, entre otros motivos, los datos ya no son necesarios para la finalidad para la que se recabaron. 
               Los interesados podrán solicitar la portabilidad de sus datos en soporte automatizado a otro responsable en los supuestos de 
               tratamientos que permite el Reglamento General de Protección de Datos. En supuestos de cancelación de los datos, únicamente los 
               conservaremos bloqueados y en cumplimiento de las obligaciones legales. Puede ejercer sus derechos mediante solicitud por escrito 
               a <a href="mailto:dpd@elcol-legi.org">dpd&#64;elcol-legi.org.</a>
            </p>
            <p class="respuesta" i18n>
                En todo caso puede presentar reclamación ante la Autoridad Catalana de Protección de Datos, 
                sita en la calle Rosselló nº 214, Esc. A, 1º 1ª, 08008 Barcelona, teléfono 935527800. 
            </p>
        </li>
    </ul>

    <footer style="text-align: right; margin: 2rem;">
        <button mat-flat-button color="primary" (click)="close()" i18n="@@Cerrar">Cerror</button>
    </footer>

</section>
